export const tr = {
    'add-creatives': 'Seçilen öğeleri ekle',
    apply: 'Uygula',
    'cancel-and-return': 'İptal',
    create: 'Yenisini oluştururken baz al',
    edit: 'Düzenle',
    'export-excel': 'Listeyi XLS dosyasına aktar',
    select: 'Seç',
    selected: '{selected} / {total} adedi seçildi'
};
